<template>
 
    <div class="row mx-0">
     
            <div class=" col-lg-6 col-md-6 col-sm-6 login-img d-flex align-items-center justify-content-center">
              <img :alt="Logo" :aria-label="Logo" src="/images/makbilllogo.png" class="img-fluid1" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 d-flex justify-content-center align-items-center auth-form">
              <form class="d-grid" @submit.prevent="otpSubmit">
                <!-- OTP Heading -->
                <div class="row justify-content-center p-2">
                  <h3 class="otp-heading">Enter Your OTP</h3>
                </div>
                <div class="row justify-content-center p-2">
                  <llp-otp-input
                    id="otp"
                    v-model:modelValue="credential.otp"
                    maxlength="6"
                    :errors="validator.credential.otp.$error"
                  >
                  </llp-otp-input>
                </div>
                <div class="row justify-content-center p-2">
                  <p v-if="errorMessage" class="text-danger otp-error">
                    {{ errorMessage }}
                  </p>
                </div>
                <div class="row justify-content-center p-2">
                  <div class="col-auto">
                    <llp-button
                      :loadSpinner="showLoginSpinner"
                      classNames="btn-secondary text-white new-btn"
                      type="submit"
                    >
                      Submit
                    </llp-button>
                  </div>
                </div>
                <div class="row text-center p-2">
                  <p>
                    <a
                      class="fw-bold"
                      @click="resendOtp"
                      :class="{ 'text-muted': isResendDisabled }"
                      :disabled="isResendDisabled"
                    >
                      Resend OTP
                      <span v-if="remainingTime > 0">({{ formattedTime }})</span>
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "../../services/network.service.js";
import ErrorService from "../../services/error.service";
export default {
  name: "OtpPage",
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      credential: {
        otp: "",
      },
      showLoginSpinner: false,
      userId: this.$route.state?.userId,
      errorMessage: null,
      timer: null,
      remainingTime: 0,
      isResendDisabled: false,
      otpExpired: false,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
     return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
    },
  },
  validations() {
    return {
      credential: {
        otp: { required: helpers.withMessage("Otp is required", required) },
      },
    };
  },
  mounted() {
    this.userId = this.$route.params.userId;
    this.remainingTime = 300; 
    this.isResendDisabled = true;
    this.startTimer();
  },
  methods: {
    startTimer() {
      // Clear previous timer if any
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.isResendDisabled = false;
          this.otpExpired = true;
        }
      }, 1000);
    },
    async otpSubmit() {
      if (!this.credential.otp) {
        this.errorMessage = "Otp is required";
        return;
      }

      if (this.otpExpired) {
        this.errorMessage = "OTP has expired, Please try again.";
        return;
      }
      this.showLoginSpinner = true;
      try {
        const data = { user_id: this.userId, otp: this.credential.otp };
        const response = await NetworkService.post(
          "/login-otp-validation",
          data,
          { includeToken: false }
        );
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("role_id",response.data.role_id)
        localStorage.setItem("userName",response.data.name);
        localStorage.setItem("wallet",response.data.walle	)
        if (response.data && response.data.token) {
          this.$refs.toast.show(response.data.message);
          // setTimeout(() => {
          //   if(response.data.role_id=='4')
          //   {
          //     this.$router.push({ path: "/services" });
          //   }else if(response.data.role_id =='2')
          //     {
          //        this.$router.push({ path: "/user-reports" });
          //     }
            
          // }, 2000);
        setTimeout(() => {
    if (response.data.role_id == 1) {
      this.$router.push({ name: "UserDetails", params: { role: 'admin' } });
    } else if (response.data.role_id == 2) {
      this.$router.push({ name: "UserDetails", params: { role: 'distributor' } });
    } else if (response.data.role_id == 3) {
      this.$router.push({ name: "UserDetails", params: { role: 'retailer' } });
    } else if (response.data.role_id == 4) {
      this.$router.push({ path: "/services" });
    } else {
      this.$refs.toast.show("Unknown role. Please contact support.", "error");
    }
  }, 2000);
        }
      } catch (error) {
        this.showLoginSpinner = false;
        this.showLoginSpinner = false;
        this.errorMessage = error.message;
      } finally {
        this.showLoginSpinner = false;
      }
    },
    async resendOtp() {
      if (this.isResendDisabled) return;
      this.errorMessage = "";
      this.credential.otp = "";
      this.otpExpired = false;
      this.isResendDisabled = true;
      this.remainingTime = 300;
      this.startTimer();
      try {
        const resendresponse = await NetworkService.post(
          "/login-resend-otp-validation",
          { user_id: this.userId },
          { includeToken: false }
        );
        this.$refs.toast.show(resendresponse.data.message,"success")
      } catch (error) {
         clearInterval(this.timer);
          this.timer = null;
          this.isResendDisabled = false;
          this.remainingTime = 0; 
        if (error.message) {
          this.$refs.toast.show("Unable to resend the OTP.", "error");
        } else {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },
  },
};
</script>

<style scoped>
a.text-muted {
  pointer-events: none;
  color: #3d3892 !important;
}

.otp-heading {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
    margin-top: 20px; 
}
</style>
